module.exports = __webpack_public_path__ + "static/media/sentiment140_scr.e89299be.png";